export function formatCurrency(value: number | string | undefined) {
  const amount = Number(value || 0);
  return new Intl.NumberFormat("zh-CN", {
    style: "currency",
    currency: "CNY",
    maximumFractionDigits: 2,
  }).format(amount);
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

export function statusTone(value?: string) {
  if (!value || value === "未发货" || value === "暂无物流") {
    return "muted";
  }
  if (value.includes("异常") || value.includes("退款")) {
    return "danger";
  }
  if (value.includes("已") || value.includes("签收")) {
    return "success";
  }
  return "neutral";
}
